import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getLanguageValue } from 'locales/i18n';
import { PAGE_TYPE } from 'enums';
import LoadingComponent from 'commons/loading/Loading.component';

interface EventItem {
    id: string;
    title: string;
    description: string;
    imageUrl: string | null;
}

interface EventIndexComponentProps {
    isLoading: boolean;
}

const EventIndexComponent: React.FC<EventIndexComponentProps> = ({
    isLoading
}) => {
    const navigate = useNavigate();

    const eventItems: EventItem[] = [
        {
            id: '2026-fortune-telling',
            title: getLanguageValue(PAGE_TYPE.STUDENT, "hubMenu.txtSajuFortuneTellingTitle"),
            description: getLanguageValue(PAGE_TYPE.STUDENT, "hubMenu.txtSajuFortuneTellingEventDesc"),
            imageUrl: '/imgs/event/icon-saju.png',
        }
    ];

    return (
        <main className="bg-gray-50 min-h-screen">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 pt-6 pb-6">
                <h1 className="text-3xl font-bold text-gray-900 mb-6">
                    {getLanguageValue(PAGE_TYPE.STUDENT, "hubMenu.txtEvent")}
                </h1>

                <div className="max-w-4xl mx-auto">
                    {isLoading ? (
                        <div className="flex justify-center items-center py-12">
                            <LoadingComponent />
                        </div>
                    ) : eventItems.length === 0 ? (
                        <div className="bg-white rounded-2xl shadow-sm p-6 text-center">
                            <div className="flex flex-col items-center justify-center text-gray-400">
                                <svg className="w-12 h-12 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" />
                                </svg>
                                <p className="text-sm">
                                    {getLanguageValue(PAGE_TYPE.STUDENT, "hubMenu.txtNoEvent")}
                                </p>
                            </div>
                        </div>
                    ) : (
                        <div className="space-y-4">
                            {eventItems.map((event) => (
                                <Link
                                    key={event.id}
                                    to={`/student/hub/event/${event.id}`}
                                    className="block bg-white rounded-2xl shadow-sm overflow-hidden hover:shadow-md transition-shadow cursor-pointer"
                                >
                                    <div className="flex items-start">
                                        {/* 이벤트 이미지 영역 (선택적) */}
                                        {event.imageUrl ? (
                                            <div className="flex-shrink-0 w-24 h-24 overflow-hidden bg-gray-100 relative">
                                                <img 
                                                    src={event.imageUrl} 
                                                    alt={event.title}
                                                    className="w-full h-full object-cover"
                                                />
                                                <div className="absolute bottom-0 left-0 right-0 bg-black/50 px-1.5 py-0.5">
                                                    <p className="text-white text-[10px] text-center">
                                                        {getLanguageValue(PAGE_TYPE.STUDENT, "hubMenu.txtEvent2026Date")}
                                                    </p>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="flex-shrink-0 w-24 h-24 bg-gradient-to-br from-[#CF3688] to-[#B82F77] flex items-center justify-center relative">
                                                <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" />
                                                </svg>
                                                <div className="absolute bottom-0 left-0 right-0 bg-black/50 px-1.5 py-0.5">
                                                    <p className="text-white text-[10px] text-center">
                                                        {getLanguageValue(PAGE_TYPE.STUDENT, "hubMenu.txtEvent2026Date")}
                                                    </p>
                                                </div>
                                            </div>
                                        )}
                                        
                                        {/* 이벤트 정보 */}
                                        <div className="flex-1 min-w-0 px-3 py-2">
                                            <h3 className="text-lg font-bold text-gray-900 mb-1 truncate">
                                                {getLanguageValue(PAGE_TYPE.STUDENT, "hubMenu.txtEvent2026Title")}
                                            </h3>
                                            <p className="text-gray-600 text-sm mb-1">
                                                {getLanguageValue(PAGE_TYPE.STUDENT, "hubMenu.txtEvent2026Subtitle")}
                                            </p>
                                        </div>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </main>
    );
};

export default EventIndexComponent;
